// ======================================================================
// File Name       : MultiLanguageEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getFormValues, reduxForm } from 'redux-form';
import * as ContentDocumentAction from '../../actions/content/ContentDocumentAction';
import * as modalActions from '../../actions/ModalAction';
import * as MultiLanguageAction from '../../actions/MultiLanguageAction';
import DialogConFirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import ModalConductor from '../../components/modal/ModalConductor';
import MultiLanguageEdit from '../../components/multiLanguage/MultiLanguageEdit';
import { HIDE_MESSAGE } from '../../constants/actionTypes/message';
import { MANAGEMENT_AUTHORITY_TYPE } from '../../constants/AuthorityConstant';
import { DOCUMENT_EDIT_TYPE, DOC_ACCEPT_FILE, PROCESS_STATUS } from '../../constants/ContentConstant';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as ModalIds from '../../constants/ModalIds';
import * as Path from '../../constants/PathConstants';
import NoImage from '../../images/no-image-icon.png';
import { downLoadFile } from '../../utils/ApiUtils';
import { getFileExtension } from '../../utils/ContentUtils';
import CustomLink from '../../components/button/CustomLink';

class MultiLanguageEditContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languageInfo: {
        contentSecernId: '',
        contentName: '',
        allLanguageCode: [],
        byLanguageCodes: {},
      },
      multiLanguageInfo: {
        contentSecernId: '',
        contentName: '',
        languageCode: '',
        multiLanguageName: '',
        documentName: '',
        documentSize: '',
        uploadFile: '',
      },
      multiLanguageConfirmInfo: {
        contentSecernId: '',
        contentName: '',
        languageCode: '',
        documentName: '',
        documentSize: '',
        uploadFile: '',
      },
      dataUrl: '',
      toShow: false,
      showModal: false,
      showDialogConfirm: false,
      showDeleteDialog: false,
    };
    this.goBack = this.goBack.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.getDataUrl = this.getDataUrl.bind(this);
    this.openDeleteConfirmDialog = this.openDeleteConfirmDialog.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteOk = this.onDeleteOk.bind(this);
    this.downloadDocument = this.downloadDocument.bind(this);
    this.onTranslateBtnClick = this.onTranslateBtnClick.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    this.getLanguageInfo(match.params.id);
  }

  componentWillUnmount() {
    this.props.dispatch(MultiLanguageAction.resetMultiLanguageInfo());
  }

  componentWillReceiveProps(nextProps) {
    const { languageInfo, isFirst, isRefreshData, multiLanguageInfo, multiLanguageEditForm } = nextProps;
    const documentContentInfo = { ...multiLanguageInfo };
    const { contentSecernId, contentName, byLanguageCode } = languageInfo;
    let selectedLanguageCode = '';
    if (multiLanguageEditForm.values.languageCode) {
      selectedLanguageCode = multiLanguageEditForm.values.languageCode;
      if (isFirst && byLanguageCode[selectedLanguageCode]) {
        if ((JSON.stringify(nextProps.languageInfo) !== JSON.stringify(this.props.languageInfo)) ||
          byLanguageCode[selectedLanguageCode].processStatus === PROCESS_STATUS.PROCESSING) {
          this.getDataUrl(byLanguageCode[selectedLanguageCode].imageUrl);
        }
      }
    }

    // Get thumbnail if user change 表示言語, upload file, translate file
    if (this.props.multiLanguageEditForm !== undefined && nextProps.multiLanguageEditForm !== undefined) {
      const currentLanguageCode = this.props.multiLanguageEditForm.values.languageCode;
      const nextLanguageCode = nextProps.multiLanguageEditForm.values.languageCode;
      const isChangeLanguageCode = currentLanguageCode && nextLanguageCode &&
        currentLanguageCode !== nextLanguageCode;

      if (byLanguageCode[selectedLanguageCode] && (isChangeLanguageCode || isRefreshData)) {
        this.getDataUrl(byLanguageCode[selectedLanguageCode].imageUrl);
      }
    }

    documentContentInfo.languageCode = selectedLanguageCode;
    documentContentInfo.contentSecernId = contentSecernId;
    documentContentInfo.contentName = contentName;

    this.setState({
      languageInfo,
      multiLanguageInfo: documentContentInfo,
      multiLanguageConfirmInfo: documentContentInfo,
    });

    // if user upload or translate file, we need to reset status
    isRefreshData && this.props.dispatch(MultiLanguageAction.resetMultiLanguageStatus());
  }

  getDataUrl(imageUrl) {
    if (imageUrl) {
      downLoadFile(imageUrl).then((blob) => {
        const reader = new FileReader();
        const blobObject = new Blob([blob]);
        reader.readAsDataURL(blobObject);
        reader.onload = () => {
          this.setState({
            toShow: true,
            dataUrl: reader.result,
          });
        };
      }).catch(() => {
        this.setState({
          toShow: true,
          dataUrl: NoImage,
        });
      });
    } else {
      this.setState({
        toShow: true,
        dataUrl: NoImage,
      });
    }
  }

  handleFileUpload() {
    const { multiLanguageConfirmInfo } = this.state;
    this.props.dispatch(MultiLanguageAction.receiveLanguageConfirmInfo(multiLanguageConfirmInfo));
    this.props.dispatch(modalActions.openModal(ModalIds.TRANSLATE_CONFIRM_DIALOG));
  }

  handleCancelClick() {
    this.setState({ showDialogConfirm: false });
  }

  onDeleteCancel() {
    this.setState({ showDeleteDialog: false });
  }

  onDeleteOk() {
    this.setState({ showDeleteDialog: false });
    const { multiLanguageInfo } = this.state;
    if (multiLanguageInfo && multiLanguageInfo.contentSecernId) {
      let params = {};
      params.editType = DOCUMENT_EDIT_TYPE.DELETE;
      params.contentSecernId = multiLanguageInfo.contentSecernId;
      params.languageCode = multiLanguageInfo.languageCode;
      this.props.dispatch(MultiLanguageAction.deleteLanguageInfo(params)).then((error) => {
        if (!error) {
          params = {};
          params.contentSecernIdList = [multiLanguageInfo.contentSecernId];
          this.props.dispatch(MultiLanguageAction.refreshLanguageInfo(params));
        }
      });
    }
  }

  goBack() {
    this.props.history.goBack();
  }

  getLanguageInfo(contentSecernId) {
    if (contentSecernId) {
      const params = {};
      params.contentSecernIdList = [contentSecernId];
      this.props.dispatch(MultiLanguageAction.getLanguageInfo(params));
    } else {
      this.setState({
        ...this.state.languageInfo,
        noRecordFound: true,
      });
    }
  }

  downloadDocument(fileName, languageCode) {
    const { match } = this.props;
    const contentSecernId = match.params.id;
    if (contentSecernId) {
      const fileType = getFileExtension(fileName).toLowerCase();
      const documentDownloadType = DOC_ACCEPT_FILE.split(',').indexOf(fileType);

      const params = {
        contentSecernId,
        documentDownloadType,
        languageCode,
      };
      this.props.dispatch(ContentDocumentAction.downloadDocument(params));
    }
  }

  openDeleteConfirmDialog() {
    this.content = MessageTemplate.MSG_TRANSLATE_DEL_DOC;
    this.mdSize = null;
    this.setState({
      showDeleteDialog: true,
    });
  }

  onTranslateBtnClick() {
    const { dispatch } = this.props;
    this.props.dispatch({ type: HIDE_MESSAGE });
    dispatch(modalActions.openModal(ModalIds.TRANSLATE_CONFIRM));
  }

  render() {
    const { multiLanguageInfo, languageInfo } = this.state;
    const { multiLanguageEditForm } = this.props;
    const { contentManagementAuthority } = this.props.authedUser.managementFunctionAuthorityInfo;
    const isReference = contentManagementAuthority === MANAGEMENT_AUTHORITY_TYPE.REFERENCE;

    if (!multiLanguageInfo || multiLanguageInfo.noRecordFound) {
      return <Redirect to={Path.MULTI_LANGUAGE_LIST} />;
    }

    let isDisableDeleteBtn = false;
    if (multiLanguageEditForm && multiLanguageEditForm.values.languageCode) {
      const selectedLanguageCode = multiLanguageEditForm.values.languageCode;
      if (selectedLanguageCode && languageInfo) {
        const { byLanguageCode } = languageInfo;
        const language = byLanguageCode[selectedLanguageCode];
        isDisableDeleteBtn = !language || parseInt(language.processStatus, 10) === PROCESS_STATUS.PROCESSING;
      }
    }
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.MULTI_LANGUAGE_LIST}
          text="対応済みドキュメントに戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="多言語ドキュメント編集" />
        <MultiLanguageEdit
          {...this.state}
          handleFileUpload={this.props.handleSubmit(this.handleFileUpload)}
          isReference={isReference}
          downloadDocument={this.downloadDocument}
          onTranslateBtnClick={this.onTranslateBtnClick}
        />
        <Col sm={12} className="text-center margin-top-20">
          {!isReference && (
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.openDeleteConfirmDialog}
              disabled={isDisableDeleteBtn}
            >
              削除
            </Button>
          )}
        </Col>
        <ModalConductor
          formKey="multiLanguageEditForm"
          history={this.props.history}
        />
        <DialogConFirm
          showModal={this.state.showDeleteDialog}
          onCancel={this.onDeleteCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDeleteOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { languageInfo, isRefreshData, isFirst, selectedLanguageCode } = state.multiLanguage;
  const { authedUser } = state.authed;
  let { multiLanguageInfo } = state.multiLanguage;
  const { multiLanguageEditForm } = state.form;
  let languageEdit = { ...multiLanguageInfo };
  if (multiLanguageEditForm && multiLanguageEditForm.values) {
    languageEdit = { ...multiLanguageEditForm.values };
    if (multiLanguageEditForm.values.uploadFile && multiLanguageEditForm.values.uploadFile.length) {
      languageEdit.documentName = multiLanguageEditForm.values.uploadFile[0].name;
      languageEdit.documentSize = multiLanguageEditForm.values.uploadFile[0].size;
    }
    languageEdit.languageCode = multiLanguageEditForm.values.languageCode || selectedLanguageCode;
  }

  const { contentSecernId, contentName } = languageInfo;
  languageEdit.contentSecernId = contentSecernId;
  languageEdit.contentName = contentName;

  multiLanguageInfo = languageEdit;
  return {
    formValues: getFormValues('multiLanguageEditForm')(state),
    ...{ languageInfo },
    ...{ multiLanguageEditForm },
    ...{ multiLanguageInfo },
    ...{ authedUser },
    initialValues: multiLanguageInfo,
    isRefreshData,
    isFirst,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'multiLanguageEditForm', // a unique identifier for this form
  enableReinitialize: true,
  touchOnChange: true,
})(MultiLanguageEditContainer));
